import { render, staticRenderFns } from "./QuickCreateWeightModal.vue?vue&type=template&id=5d5ac63d&"
import script from "./QuickCreateWeightModal.vue?vue&type=script&lang=js&"
export * from "./QuickCreateWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports